import {useSearchParams} from "react-router-dom";
import useApiCall, {ApiCallResponseData, makeApiCall} from "../hooks/CancellableApiCall";
import React, {useState} from "react";
import {Box, Button, Divider, Pagination, Paper, Stack, Typography} from "@mui/material";
import {NotificationResponse} from "../data/NotificationResponse";
import NotificationsIcon from "@mui/icons-material/Notifications";
import {DoneAll} from "@mui/icons-material";
import {NotificationPanel} from "../components/NotificationPanel";


interface NotificationPaginationResponse {
    notifications: NotificationResponse[],
    pages: number,
    totalNotifications: number
}

export const NotificationsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const page = parseInt(searchParams.get("page") ?? "1")
    const [changeApiCall, setChangeApiCall] = useState<ApiCallResponseData>()
    const loadNotifications = useApiCall<NotificationPaginationResponse>({
        url: `/api/notification?page=${page}`
    })

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        searchParams.set("page", value.toString())
        setSearchParams(searchParams)
    }

    const deleteNotification = (id: number) => {
        changeApiCall?.cancel()
        setChangeApiCall(makeApiCall({
            url: `/api/notification/${id}`,
            method: "DELETE",
            onLoadedCallback: () => {
                loadNotifications.refresh()
            },
            onError: () => {
            },
        }))
    }

    const markNotificationRead = (id: number, read: boolean) => {
        changeApiCall?.cancel()
        setChangeApiCall(makeApiCall({
            url: `/api/notification/${id}/read?read=${read}`,
            method: "PUT",
            onLoadedCallback: () => {
                loadNotifications.refresh()
            },
            onError: () => {
            },
        }))
    }

    const readAllNotifications = () => {
        changeApiCall?.cancel()
        setChangeApiCall(makeApiCall({
            url: "/api/notification/read-all",
            method: "POST",
            onLoadedCallback: () => {
                loadNotifications.refresh()
            },
            onError: () => {
            },
        }))
    }

    const totalPages = Math.max(loadNotifications.data?.pages ?? 1, 1)
    const notifications = loadNotifications.data?.notifications ?? []
    const totalNotifications = loadNotifications.data?.totalNotifications ?? 0

    return (
        <Paper variant={"outlined"} sx={{p: 0, overflow: "hidden"}}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{px: 3, py: 2}}>
                <Stack spacing={1} direction="row" alignItems="center">
                    <NotificationsIcon color="primary"/>
                    <Typography variant="h6">Notifications</Typography>
                    {totalNotifications > 0 && (
                        <Typography variant="body2" color="text.secondary">
                            ({totalNotifications})
                        </Typography>
                    )}
                </Stack>
                {notifications.length > 0 && (
                    <Button
                        size="small"
                        variant="text"
                        startIcon={<DoneAll/>}
                        onClick={readAllNotifications}
                    >
                        Mark all read
                    </Button>
                )}
            </Stack>
            <Divider/>

            <NotificationPanel
                notifications={notifications}
                isLoading={loadNotifications.isLoading}
                onMarkRead={markNotificationRead}
                onDelete={deleteNotification}
                onReadAll={readAllNotifications}
            />

            <Box sx={{justifyContent: "center", display: "flex", width: "100%", py: 2}}>
                <Pagination color={'secondary'} count={totalPages} page={page}
                            onChange={handleChange}/>
            </Box>
        </Paper>
    )
}